import type { FilterExpression } from "@sg-protect/core";
import type { EditableExpression } from "../expressions/base/types.ts";

export const extractEditableExpressions = (expression?: FilterExpression): EditableExpression[] => {
    const filters: EditableExpression[] = [];

    if (expression) {
        const collectFilters = (expr: FilterExpression) => {
            if (expr.type === "logical") {
                collectFilters(expr.left);
                collectFilters(expr.right);

                return;
            }

            if (expr.type === "group") {
                collectFilters(expr.inner);

                return;
            }

            filters.push(expr as EditableExpression);
        };

        collectFilters(expression);
    }

    return filters;
};
